<!-- Trailer Modal - Place at the very top -->
<div class="trailer-modal-backdrop" *ngIf="showPlayer" (click)="closeTrailer()" [@fadeIn]>
  <div class="trailer-modal-container" (click)="$event.stopPropagation()">
    <!-- Close Button -->
    <button class="trailer-close-btn" (click)="closeTrailer()" aria-label="Close trailer">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
    
    <!-- Trailer Player -->
    <div class="trailer-content">
      <div class="trailer-container" id="trailer-player"></div>
    </div>
  </div>
</div>

<div class="document">
  <app-normal-navbar></app-normal-navbar>
  <app-movie-details [(showPlayer)]="showPlayer"></app-movie-details>
  <app-movie-credits></app-movie-credits>
  <app-movie-linked-videos></app-movie-linked-videos>
  <section class="flex-parent">
    <div class="tv-left">
      <app-movie-recommendations class="recommendations" [(showPlayer)]="showPlayer"></app-movie-recommendations>
    </div>
    <div class="tv-right">
      <app-movie-accounts></app-movie-accounts>
      <app-movie-facts class="facts"></app-movie-facts>
    </div>
  </section>
  <app-footer></app-footer>
</div>